import { __rest } from 'tslib';
import React, { forwardRef } from 'react';
import { Pin2 } from '@piiqtechnologies/svg-icons';
import { ViewerPopperActionControl } from '../../../../components/viewer-action/ViewerPopperActionControl.js';
import { ViewerActionButton } from '../../../../components/viewer-action/ViewerActionButton.js';
import '@piiqtechnologies/ui-components';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../../../utils/ErrorProvider.js';
import '../../../../../utils/LoaderProvider.js';
import '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import '../../../../../utils/ContactProvider.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../components/viewer-action/ViewerOutlinedActionButton.js';
import '../../../../components/pannellum-viewer/PannellumProvider.js';
import { RoomsDetails } from './RoomsDetails.js';

const RoomsControlButton = forwardRef((_a, ref) => {
    var { onActionClick } = _a, props = __rest(_a, ["onActionClick"]);
    return (React.createElement(ViewerActionButton, Object.assign({ ref: ref, Icon: Pin2, IconProps: { width: 24, height: 24 }, onClick: onActionClick, sx: {
            backgroundColor: "grey.50",
            color: "primary.main",
            height: 53,
            width: 84,
            ":hover": {
                backgroundColor: "grey.50",
            },
        } }, props)));
});
RoomsControlButton.displayName = "RoomsControlButton";
const RoomsControl = () => {
    return (React.createElement(ViewerPopperActionControl, { isEditorMode: true, actionId: "rooms-navigation", actionDetailsPositioningStrategy: "absolute", ActionButton: RoomsControlButton }, ({ onActionDetailsClose }) => React.createElement(RoomsDetails, { onRoomSelect: onActionDetailsClose })));
};

export { RoomsControl, RoomsControl as default };
